import { Src_Inst } from './src_inst';
import { Attribute } from './attribute';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { RepConn } from '../datapoint/repconn';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { DataObject } from './dataobject';
import { Tx_Inst_Property } from './tx_inst_property';

import { CommonEnums } from 'src/app/shared/common.enums';
import { Tx_Inst_PropertiesUtil } from 'src/app/shared/utils/tx_inst_properties.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';

export class Source {
     src_Inst: Src_Inst;
     attributes: Array<Attribute>;
     derivedAttributes: Array<Attribute>;
     extract_Properties: Array<Obj_Db_Property>;
     load_Properties: Array<Obj_Db_Property>;
     param_Properties: Array<Obj_Db_Property>;
     pagination_Properties: Array<Obj_Db_Property>;
     header_Properties: Array<Obj_Db_Property>;
     waterMark_Properties: Array<Obj_Db_Property>;
     properties: Array<Obj_Db_Property>;
     searchTerm_Properties: Array<Obj_Db_Property>;
     repConn: RepConn;
     tx_Inst_Properties: Array<Tx_Inst_Property>;
     sel_Load_PropertyType_Cd: string;
     loadPropertyTypes: Array<Db_PropertyType>;
     sel_Extract_PropertyType_Cd: string;
     extractPropertyTypes: Array<Db_PropertyType>;
     //   filepropertieyTypes: Array<Db_PropertyType>;
     isNativeFlg: boolean;
     dataObject: DataObject;
     nativeDbTyp_Id: number;
     change_Ind: string;
     error_Cd: string;
     error_Msg: string;
     ref_Id: number;
     ref_Cd: string;
     fldr_Id: number;
     imageUrl: string;
     sel_Run_PropertyType_Cd: string;
     run_Properties: Array<Obj_Db_Property>;
     runPropertyTypes: Array<Db_PropertyType>;
     gen_Tab_Change_Ind: string;
     prop_Tab_Change_Ind: string;
     srcAttr_Tab_Change_Ind: string;
     attr_Tab_Change_Ind: string;
     eProp_Tab_Change_Ind: string;
     lProp_Tab_Change_Ind: string;
     rProp_Tab_Change_Ind: string;
     restProp_Tab_Change_Ind: string;
     wProp_Tab_Change_Ind: string;
     scopeProp_Tab_Change_Ind: string;
     tmeRngeProp_Tab_Change_Ind: string;
     fltrProp_Tab_Change_Ind: string;
     scope_Properties: Array<Obj_Db_Property>;
     filter_Properties: Array<Obj_Db_Property>;
     timeRange_Properties: Array<Obj_Db_Property>;
     searchTermsFlag: string;

     constructor() {
          this.setDefaults()
     }

     setDefaults(): void {
          this.dataObject = new DataObject();
          this.src_Inst = new Src_Inst();
          this.attributes = new Array<Attribute>();
          this.derivedAttributes = new Array<Attribute>();
          this.tx_Inst_Properties = new Array<Tx_Inst_Property>();

          this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
          this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
          this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
          this.ref_Id = CommonEnums.defaults.LONG_VAL;
          this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
          this.fldr_Id = CommonEnums.defaults.LONG_VAL;
          this.imageUrl = CommonEnums.defaults.STRING_EMPTY;


          this.sel_Extract_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
          this.sel_Load_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
          this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
          this.isNativeFlg = true;

          this.extract_Properties = new Array<Obj_Db_Property>();
          this.load_Properties = new Array<Obj_Db_Property>();
          this.param_Properties = new Array<Obj_Db_Property>();
          this.pagination_Properties = new Array<Obj_Db_Property>();
          this.header_Properties = new Array<Obj_Db_Property>();
          this.waterMark_Properties = new Array<Obj_Db_Property>();
          this.properties = new Array<Obj_Db_Property>();
          this.searchTerm_Properties = new Array<Obj_Db_Property>();
          this.run_Properties = new Array<Obj_Db_Property>();
          this.scope_Properties = new Array<Obj_Db_Property>();
          this.filter_Properties = new Array<Obj_Db_Property>();
          this.timeRange_Properties = new Array<Obj_Db_Property>();


          this.extractPropertyTypes = new Array<Db_PropertyType>();
          this.loadPropertyTypes = new Array<Db_PropertyType>();
          this.runPropertyTypes = new Array<Db_PropertyType>();
          //this.filepropertieyTypes = new Array<Db_PropertyType>();

          this.repConn = new RepConn();

          this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.prop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.srcAttr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.eProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.lProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.restProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.wProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.scopeProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.tmeRngeProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
          this.fltrProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

          this.searchTermsFlag = CommonEnums.defaults.STRING_VAL_NO;
     }

     static parse(sourceTmp: Source): Source {
          let source: Source = new Source();
          source.copyFrom(sourceTmp);
          return source;
     }

     copy(): Source {
          let sourceTmp: Source = new Source();

          sourceTmp.src_Inst = this.src_Inst.copy();

          let attributesUtil: AttributesUtil = AttributesUtil.getInstance();
          sourceTmp.attributes = attributesUtil.copy(this.attributes);
          sourceTmp.derivedAttributes = attributesUtil.copy(this.derivedAttributes);

          sourceTmp.tx_Inst_Properties = Tx_Inst_PropertiesUtil.getInstance().copy(this.tx_Inst_Properties);

          sourceTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
          sourceTmp.change_Ind = this.change_Ind;
          sourceTmp.error_Cd = this.error_Cd;
          sourceTmp.error_Msg = this.error_Msg;
          sourceTmp.ref_Id = this.ref_Id;
          sourceTmp.ref_Cd = this.ref_Cd;
          sourceTmp.fldr_Id = this.fldr_Id;
          sourceTmp.imageUrl = this.imageUrl;

          sourceTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
          sourceTmp.sel_Load_PropertyType_Cd = this.sel_Load_PropertyType_Cd;
          sourceTmp.sel_Extract_PropertyType_Cd = this.sel_Extract_PropertyType_Cd;
          sourceTmp.isNativeFlg = this.isNativeFlg;

          let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
          sourceTmp.extract_Properties = obj_Db_PropertiesUtil.copy(this.extract_Properties);
          sourceTmp.load_Properties = obj_Db_PropertiesUtil.copy(this.load_Properties);
          sourceTmp.param_Properties = obj_Db_PropertiesUtil.copy(this.param_Properties);
          sourceTmp.pagination_Properties = obj_Db_PropertiesUtil.copy(this.pagination_Properties);
          sourceTmp.header_Properties = obj_Db_PropertiesUtil.copy(this.header_Properties);
          sourceTmp.waterMark_Properties = obj_Db_PropertiesUtil.copy(this.waterMark_Properties);
          sourceTmp.properties = obj_Db_PropertiesUtil.copy(this.properties);
          sourceTmp.searchTerm_Properties = obj_Db_PropertiesUtil.copy(this.searchTerm_Properties)
          sourceTmp.run_Properties = obj_Db_PropertiesUtil.copy(this.run_Properties);
          sourceTmp.scope_Properties = obj_Db_PropertiesUtil.copy(this.scope_Properties);
          sourceTmp.filter_Properties = obj_Db_PropertiesUtil.copy(this.filter_Properties);
          sourceTmp.timeRange_Properties = obj_Db_PropertiesUtil.copy(this.timeRange_Properties);

          let db_PropertyTypesUtil: Db_PropertyTypesUtil = Db_PropertyTypesUtil.getInstance();
          sourceTmp.extractPropertyTypes = db_PropertyTypesUtil.copy(this.extractPropertyTypes);
          sourceTmp.loadPropertyTypes = db_PropertyTypesUtil.copy(this.loadPropertyTypes);
          sourceTmp.runPropertyTypes = db_PropertyTypesUtil.copy(this.runPropertyTypes);

          sourceTmp.dataObject = this.dataObject;
          sourceTmp.repConn = this.repConn;

          sourceTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
          sourceTmp.prop_Tab_Change_Ind = this.prop_Tab_Change_Ind;
          sourceTmp.srcAttr_Tab_Change_Ind = this.srcAttr_Tab_Change_Ind;
          sourceTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
          sourceTmp.eProp_Tab_Change_Ind = this.eProp_Tab_Change_Ind;
          sourceTmp.lProp_Tab_Change_Ind = this.lProp_Tab_Change_Ind;
          sourceTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;
          sourceTmp.restProp_Tab_Change_Ind = this.restProp_Tab_Change_Ind;
          sourceTmp.wProp_Tab_Change_Ind = this.wProp_Tab_Change_Ind;
          sourceTmp.scopeProp_Tab_Change_Ind = this.scopeProp_Tab_Change_Ind;
          sourceTmp.tmeRngeProp_Tab_Change_Ind = this.tmeRngeProp_Tab_Change_Ind;
          sourceTmp.fltrProp_Tab_Change_Ind = this.fltrProp_Tab_Change_Ind;

          sourceTmp.searchTermsFlag = this.searchTermsFlag;

          return sourceTmp;
     }

     copyFrom(sourceTmp: Source): void {
          this.src_Inst.copyFrom(sourceTmp.src_Inst);
          if (sourceTmp.dataObject.attributes == null)
               sourceTmp.dataObject.attributes = new Array<Attribute>();

          this.dataObject = sourceTmp.dataObject;
          this.repConn = sourceTmp.repConn;

          this.nativeDbTyp_Id = sourceTmp.nativeDbTyp_Id;
          this.change_Ind = sourceTmp.change_Ind;
          this.error_Cd = sourceTmp.error_Cd;
          this.error_Msg = sourceTmp.error_Msg;
          this.ref_Id = sourceTmp.ref_Id;
          this.ref_Cd = sourceTmp.ref_Cd;
          this.fldr_Id = sourceTmp.fldr_Id;
          this.imageUrl = sourceTmp.imageUrl;

          this.sel_Extract_PropertyType_Cd = sourceTmp.sel_Extract_PropertyType_Cd;
          this.isNativeFlg = sourceTmp.isNativeFlg;
          this.sel_Load_PropertyType_Cd = sourceTmp.sel_Load_PropertyType_Cd;
          this.sel_Run_PropertyType_Cd = sourceTmp.sel_Run_PropertyType_Cd;

          let attributesUtil: AttributesUtil = AttributesUtil.getInstance();
          attributesUtil.copyFrom(this.attributes, sourceTmp.attributes);
          attributesUtil.copyFrom(this.derivedAttributes, sourceTmp.derivedAttributes);

          let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
          obj_Db_PropertiesUtil.copyFrom(this.extract_Properties, sourceTmp.extract_Properties);
          obj_Db_PropertiesUtil.copyFrom(this.load_Properties, sourceTmp.load_Properties);
          obj_Db_PropertiesUtil.copyFrom(this.run_Properties, sourceTmp.run_Properties);
          obj_Db_PropertiesUtil.copyFrom(this.scope_Properties, sourceTmp.scope_Properties);
          obj_Db_PropertiesUtil.copyFrom(this.filter_Properties, sourceTmp.filter_Properties);
          obj_Db_PropertiesUtil.copyFrom(this.timeRange_Properties, sourceTmp.timeRange_Properties);
          obj_Db_PropertiesUtil.copyFrom(this.param_Properties, sourceTmp.param_Properties);
          obj_Db_PropertiesUtil.copyFrom(this.header_Properties, sourceTmp.header_Properties);
          obj_Db_PropertiesUtil.copyFrom(this.pagination_Properties,sourceTmp.pagination_Properties);
          obj_Db_PropertiesUtil.copyFrom(this.waterMark_Properties, sourceTmp.waterMark_Properties);
          obj_Db_PropertiesUtil.copyFrom(this.properties, sourceTmp.properties);
          obj_Db_PropertiesUtil.copyFrom(this.searchTerm_Properties, sourceTmp.searchTerm_Properties);

          let db_PropertyTypesUtil: Db_PropertyTypesUtil = Db_PropertyTypesUtil.getInstance();
          //db_PropertyTypesUtil.copyFrom(this.filepropertieyTypes, sourceTmp.filepropertieyTypes);
          db_PropertyTypesUtil.copyFrom(this.extractPropertyTypes, sourceTmp.extractPropertyTypes)
          db_PropertyTypesUtil.copyFrom(this.loadPropertyTypes, sourceTmp.loadPropertyTypes);
          db_PropertyTypesUtil.copyFrom(this.runPropertyTypes, sourceTmp.runPropertyTypes);

          Tx_Inst_PropertiesUtil.getInstance().copyFrom(this.tx_Inst_Properties, sourceTmp.tx_Inst_Properties);

          this.gen_Tab_Change_Ind = sourceTmp.gen_Tab_Change_Ind;
          this.prop_Tab_Change_Ind = sourceTmp.prop_Tab_Change_Ind;
          this.srcAttr_Tab_Change_Ind = sourceTmp.srcAttr_Tab_Change_Ind;
          this.attr_Tab_Change_Ind = sourceTmp.attr_Tab_Change_Ind;
          this.eProp_Tab_Change_Ind = sourceTmp.eProp_Tab_Change_Ind;
          this.lProp_Tab_Change_Ind = sourceTmp.lProp_Tab_Change_Ind;
          this.rProp_Tab_Change_Ind = sourceTmp.rProp_Tab_Change_Ind;
          this.restProp_Tab_Change_Ind = sourceTmp.restProp_Tab_Change_Ind;
          this.wProp_Tab_Change_Ind = sourceTmp.wProp_Tab_Change_Ind;
          this.scopeProp_Tab_Change_Ind = sourceTmp.scopeProp_Tab_Change_Ind;
          this.tmeRngeProp_Tab_Change_Ind = sourceTmp.tmeRngeProp_Tab_Change_Ind;
          this.fltrProp_Tab_Change_Ind = sourceTmp.fltrProp_Tab_Change_Ind;

          this.searchTermsFlag = sourceTmp.searchTermsFlag;
     }

     compare(sourceTmp: Source): string {
          let sourceString: string = this.toString(false);
          let sourceTmpString: string = sourceTmp.toString(false);

          if (sourceString != sourceTmpString) {
               return sourceString + ', ' + sourceTmpString;
          }

          return '';
     }

     toString(isNotCompare: boolean = true): string {
          let attributesUtil: AttributesUtil = AttributesUtil.getInstance();
          let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
          let db_PropertyTypesUtil: Db_PropertyTypesUtil = Db_PropertyTypesUtil.getInstance();

          return "Source [ src_Inst=" + this.src_Inst.toString() +
               ", attributes=" + attributesUtil.toString(this.attributes) +
               ", derivedAttributes=" + attributesUtil.toString(this.derivedAttributes) +
               ", extract_Properties=" + obj_Db_PropertiesUtil.toString(this.extract_Properties) +
               ", load_Properties=" + obj_Db_PropertiesUtil.toString(this.load_Properties) +
               ", param_Properties=" + obj_Db_PropertiesUtil.toString(this.param_Properties) +
               ", header_Properties=" + obj_Db_PropertiesUtil.toString(this.header_Properties) +
               ", waterMark_Properties=" + obj_Db_PropertiesUtil.toString(this.waterMark_Properties) +
               ", properties=" + obj_Db_PropertiesUtil.toString(this.properties) +
               ", searchTerm_Properties=" + obj_Db_PropertiesUtil.toString(this.searchTerm_Properties) +
               ", repConn=" + this.repConn +
               ", tx_Inst_Properties=" + Tx_Inst_PropertiesUtil.getInstance().toString(this.tx_Inst_Properties) +
               ", sel_Load_PropertyType_Cd=" + this.sel_Load_PropertyType_Cd +
               ", loadPropertyTypes=" + db_PropertyTypesUtil.toString(this.loadPropertyTypes) +
               ", sel_Extract_PropertyType_Cd=" + this.sel_Extract_PropertyType_Cd +
               ", extractPropertyTypes=" + db_PropertyTypesUtil.toString(this.extractPropertyTypes) +
               ", isNativeFlg=" + this.isNativeFlg +
               ", dataObject=" + this.dataObject.toString() +
               ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
               ", change_Ind=" + this.change_Ind +
               ", error_Cd=" + this.error_Cd +
               ", error_Msg=" + this.error_Msg +
               ", ref_Id=" + this.ref_Id +
               ", ref_Cd=" + this.ref_Cd +
               ", fldr_Id=" + this.fldr_Id +
               ", imageUrl=" + this.imageUrl +
               ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd +
               ", run_Properties=" + obj_Db_PropertiesUtil.toString(this.run_Properties) +
               ", runPropertyTypes=" + db_PropertyTypesUtil.toString(this.runPropertyTypes) +
               ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind +
               ", prop_Tab_Change_Ind=" + this.prop_Tab_Change_Ind +
               ", srcAttr_Tab_Change_Ind=" + this.srcAttr_Tab_Change_Ind +
               ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind +
               ", eProp_Tab_Change_Ind=" + this.eProp_Tab_Change_Ind +
               ", lProp_Tab_Change_Ind=" + this.lProp_Tab_Change_Ind +
               ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind +
               ", restProp_Tab_Change_Ind=" + this.restProp_Tab_Change_Ind +
               ", wProp_Tab_Change_Ind=" + this.wProp_Tab_Change_Ind +
               ", scopeProp_Tab_Change_Ind=" + this.scopeProp_Tab_Change_Ind +
               ", tmeRngeProp_Tab_Change_Ind=" + this.tmeRngeProp_Tab_Change_Ind +
               ", fltrProp_Tab_Change_Ind=" + this.fltrProp_Tab_Change_Ind +
               ", scope_Properties=" + obj_Db_PropertiesUtil.toString(this.scope_Properties) +
               ", filter_Properties=" + obj_Db_PropertiesUtil.toString(this.filter_Properties) +
               ", timeRange_Properties=" + obj_Db_PropertiesUtil.toString(this.timeRange_Properties) + 
               ", searchTermsFlag=" + this.searchTermsFlag + "]";
     }
}